var _path, _path2, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 1038,
    viewBox: "0 0 96 1038",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.8906 74.3333C91.8361 74.3333 94.2239 71.9455 94.2239 69C94.2239 66.0545 91.8361 63.6667 88.8906 63.6667C85.9451 63.6667 83.5573 66.0545 83.5573 69C83.5573 71.9455 85.9451 74.3333 88.8906 74.3333ZM89.8906 535L89.8906 69L87.8906 69L87.8906 535L89.8906 535Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3594 400L123.422 343L123.422 1168L54.3593 1168L54.3594 400Z",
    fill: "#00A9B1"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 17,
    x2: 36,
    y2: 370,
    stroke: "black",
    strokeWidth: 6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 54,
    y1: 305,
    x2: 54,
    y2: 413,
    stroke: "#3ED4DC",
    strokeWidth: 6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: -2.62268e-7,
    y1: 3,
    x2: 53,
    y2: 3,
    stroke: "#3ED4DC",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundRight);
export default __webpack_public_path__ + "static/media/background-right.fc9722cc5fa21a2a84b1575ad89a5615.svg";
export { ForwardRef as ReactComponent };